// Stretches of a video that actually played, as sorted, non-overlapping
// [start, end] pairs in content seconds (e.g. [[0, 27.7], [120, 180]]).
//
// Only normal playback adds a stretch: a seek or a click on the end of the
// seek bar adds nothing, so skipping ahead can no longer read as having
// watched the skipped part. Rewatching a stretch adds no new coverage.
//
// Keep in sync with watchedRanges in video-tracker-service/activityMerge.mjs
// and video-tracker-reporting/orientation.mjs (separate deploy bundles).

// Consecutive progress ticks share an endpoint; this also absorbs float noise.
const JOIN_GAP_SECONDS = 0.5;

const round = (n) => Math.round(n * 10) / 10;

export const normalizeRanges = (ranges) => {
  const valid = (Array.isArray(ranges) ? ranges : [])
    .map((r) => [Number(r?.[0]), Number(r?.[1])])
    .filter(([s, e]) => Number.isFinite(s) && Number.isFinite(e) && e > s)
    .map(([s, e]) => [Math.max(0, s), e])
    .sort((a, b) => a[0] - b[0]);

  const out = [];
  for (const [s, e] of valid) {
    const last = out[out.length - 1];
    if (last && s <= last[1] + JOIN_GAP_SECONDS) {
      last[1] = Math.max(last[1], e);
    } else {
      out.push([s, e]);
    }
  }
  return out.map(([s, e]) => [round(s), round(e)]);
};

export const addWatchedRange = (ranges, from, to) =>
  normalizeRanges([...(Array.isArray(ranges) ? ranges : []), [from, to]]);

export const mergeWatchedRanges = (a, b) =>
  normalizeRanges([
    ...(Array.isArray(a) ? a : []),
    ...(Array.isArray(b) ? b : []),
  ]);

export const coveredSeconds = (ranges) =>
  normalizeRanges(ranges).reduce((sum, [s, e]) => sum + (e - s), 0);
